
import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import AssetActiveService from "../../../services/reports/asset-active-service.js";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../components/template/template.jsx";
import Button from "../../../components/button/button.jsx";
import {FaPrint} from "react-icons/fa6";
import PrintTemplate from "../../../components/reports/print-reports/print-template.jsx";
import AssetsTableRow from "./componentes/assets-table-row.jsx";
import AssetsTableHeader from "./componentes/assets-table-header.jsx";
import {Card} from "../../../components/card/card.jsx"
import HeaderTemplateButton from "../../../components/button/header-template-button.jsx";

const statusList = [
    {value: "active", label: "Ativo"},
    {value: "decrease", label: "Baixado"}
]

const typeList = [
    {value: "electronic", label: "Eletrônico"},
    {value: "furniture", label: "Mobiliário"},
]
const AssetActive = () => {
    const printComponentRef = useRef(null);
    const [assets, setAssets] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filtersToPrint, setFiltersToPrint] = useState("");
    const [filters, setFilters] = useState(undefined);
    const [canPrint, setCanPrint] = useState(false);
    const [headerSelected, setHeaderSelected] = useState(-1);

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const {isLoading: isLoadingAssets} = useQuery({
        queryFn: async () => {
            const fetchedData = await AssetActiveService.getAssets(filters).then(({data}) => {
                return data.map(row => {
                    return {
                        ...row,
                        status: statusList.find(item => item.value === row.status)?.label || row.status,
                        type: typeList.find(item => item.value === row.type)?.label || row.type
                    };
                });
            });

            if (fetchedData && fetchedData.length > 0) {
                setAssets(fetchedData);

                await delay(500);

                setCanPrint(true);
            }

            return fetchedData || [];
        },
        queryKey: ['assets', filters],
        enabled: !!filters
    });

    useLayoutEffect(() => {
        if (canPrint) printComponentRef.current?.print()
    }, [canPrint]);

    useEffect(() => {
        let filtersParsed;
        let filtersToAppend;
        const filtersDecode = localStorage.getItem("filter_asset_active");
        const searchWithoutFilter = localStorage.getItem("search_without_filter");

        if (searchWithoutFilter && !filtersDecode) {
            setFilters([]);
            localStorage.removeItem("search_without_filter");
        } else if (filtersDecode) {
            filtersParsed = JSON.parse(filtersDecode);
            setFilters(filtersParsed);

            const lang = {
                description: "Descrição",
                asset_number: "Patrimônio",
                serial_number: "Série",
                place: "Local",
                brand: "Marca",
                model: "Modelo",
                status: "Status",
                type: "Tipo",
                supplier: "Fornecedor",
            }

            const parseSelect = (value, field, selectList) => {
                const label = selectList.find(item => item.value === value).label;
                return lang[field] + ": " + label;
            };

            const prepareDate = (value) => {
                if (value.dateStart && value.dateEnd) return "Início da garantia: " + value.dateStart + "; Fim da garantia: " + value.dateEnd

                return ""
            }

            filtersToAppend = Object.entries(filtersParsed)
                .filter(([field, value]) => value !== '' && value !== null).map(([field, value]) => {
                    if (field === "warranty") return prepareDate(value);
                    if (field === "status") return parseSelect(value, field, statusList);
                    if (field === "type") return parseSelect(value, field, typeList);

                    return `${lang[field]}: ${value}`;
                }).join("; ");
        }

        if (filtersParsed) setFiltersToPrint(filtersToAppend)

        localStorage.removeItem("filter_asset_active");

    }, []);

    return (
       <>
           <Template isLoading={isLoading || isLoadingAssets}>
               <Template.Header>
                   <div className="flex justify-between w-full">
                       <Template.Title>
                           Ativos
                       </Template.Title>
                       {
                           assets.length > 0 &&
                               <div className={"flex flex-row h-[30px] gap-2"}>
                                   <Button title="Imprimir" onClick={() => printComponentRef.current?.print()}>
                                   <FaPrint/>
                               </Button>
                               <HeaderTemplateButton selected={headerSelected} setSelected={setHeaderSelected} />
                           </div>
                       }
                   </div>
               </Template.Header>
               <Template.Body>
                   <Card>
                       <Card.Body>
                           <PrintTemplate
                               entity={headerSelected}
                               title={"Ativos"}
                               ref={printComponentRef}
                               setIsPrinting={setIsLoading}
                           >
                               {
                                   assets.length > 0 &&
                                   <div className="bg-white">
                                       <div className="w-full">{filtersToPrint}</div>
                                       <table className="min-w-full">
                                           <AssetsTableHeader />
                                           <tbody className="bg-white divide-y divide-gray-200">
                                           {assets.map((asset, index) => (
                                               <AssetsTableRow
                                                   key={index}
                                                   asset={asset}
                                               />
                                           ))}
                                           </tbody>
                                       </table>
                                   </div>
                               }
                           </PrintTemplate>
                       </Card.Body>
                   </Card>
               </Template.Body>
           </Template>
       </>
    );
};

export default AssetActive;